import { Typography, Divider } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
    ONE_TO_SIX_OPTIONS_MAX, ONE_TO_SIX_OPTIONS_MIN,
    RURAL_CHECKBOX_FILTER_LABELS, RURAL_RANGE_FILTER_LABELS
} from 'constants/filterOptions';
import Box from '@mui/material/Box';
import React from 'react';
import CheckboxFilter from 'components/commons/CheckboxFilter';
import RangeAutocomplete from 'components/FilterFields/RangeAutocomplete';
import { validateCharacters, validateDecimalPlaces, validateMaxLength } from 'lib/Validations';

function RuralFilter(props) {
    const validateInput = (input) => {
        return (
            validateMaxLength(input) ||
            validateCharacters(input) ||
            validateDecimalPlaces(input)
        );
    };
    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>Rural</Typography>
            <Grid container>
                {
                    Object.keys(RURAL_CHECKBOX_FILTER_LABELS).map((value) => {
                        return (
                            <Grid item size={4} key={value}>
                                <CheckboxFilter
                                    value={RURAL_CHECKBOX_FILTER_LABELS[value]}
                                    comparableType={props.comparableType}
                                    attrName={value}
                                />
                            </Grid>
                        );
                    })
                }
            </Grid>
            <Divider orientation="horizontal" sx={{mb:3, mt:3}}/>
            <Grid container spacing={3}>
                {
                    Object.keys(RURAL_RANGE_FILTER_LABELS).map((value) => {
                        return (
                            <Grid item size={4} key={value}>
                                <RangeAutocomplete
                                    comparableType={props.comparableType}
                                    attrName={value}
                                    label={RURAL_RANGE_FILTER_LABELS[value]}
                                    subLabel="Select an option or manually enter a value"
                                    minOptions={ONE_TO_SIX_OPTIONS_MIN}
                                    maxOptions={ONE_TO_SIX_OPTIONS_MAX}
                                    isDropdown={false}
                                    validateInput={validateInput}
                                />
                            </Grid>
                        );
                    })
                }
            </Grid>
            <Divider orientation="horizontal" sx={{mb:3, mt:3}}/>
        </Box>
    );
}

export default React.memo(RuralFilter);